import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import SafeFeedbackTipoFormularioGrid from './SafeFeedbackTipoFormularioGrid.jsx'
import SafeFeedbackTipoFormularioAbm from './SafeFeedbackTipoFormularioAbm.js'
import {FormattedMessage, injectIntl} from 'react-intl';

class SafeFeedbackTipoFormulario extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="SafeFeedbackTipoFormulario.tipo_formularios.label_administracion_tipos_relatos" defaultMessage="Administración de Tipos de Relatos"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={SafeFeedbackTipoFormularioGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <SafeFeedbackTipoFormularioAbm {...props} intl={this.props.intl} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <SafeFeedbackTipoFormularioAbm {...props} intl={this.props.intl} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <SafeFeedbackTipoFormularioAbm {...props} action="VIEW" />} />
					</Switch>
				</div>
			</div>
	    );
  	}
}

export default injectIntl(SafeFeedbackTipoFormulario);